module.exports = __webpack_public_path__ + "static/6-0d5534a73be518cdf328e144c7fc9974.jpg";